export default class LeadsOrderType {
  constructor(id, desc) {
    this.desc = desc;
    this.id = id;
  }

  getDesc() {
    return this.desc;
  }

  getId() {
    return this.id;
  }
}

LeadsOrderType.DEFAULT = new LeadsOrderType(1, '默认排序');
LeadsOrderType.SCORE = new LeadsOrderType(2, '智能排序');

Object.freeze(LeadsOrderType);
